jQuery(document).ready(function($) {

  if ( $('.o-slash-list')[0] ) {
    var tempSliderInit = 0;
    $(window).on('resize load', function () {
      if ($(this).width() <= 600) {
        if (!tempSliderInit) {
          $('.o-slash-list__list').slick({
            prevArrow:
              `<button
                class="o-slash-list__arrow o-slash-list__arrow--prev slick-prev a-expandable-arrow-button a-expandable-arrow-button--left a-expandable-arrow-button--point-left"
                type="button"
                aria-label="Previous Image"
              >
                <span class="a-expandable-arrow-button__circle">
                  <span class="a-expandable-arrow-button__text">Prev</span>
                  <i class="a-expandable-arrow-button__arrow"></i>
                </span>
              </button>`,
            nextArrow:
              `<button
                class="o-slash-list__arrow o-slash-list__arrow--next slick-next a-expandable-arrow-button"
                type="button"
                aria-label="Next Image"
              >
                <span class="a-expandable-arrow-button__circle">
                  <span class="a-expandable-arrow-button__text">Next</span>
                  <i class="a-expandable-arrow-button__arrow"></i>
                </span>
              </button>`,
            adaptiveHeight: true
          });
        }
        tempSliderInit = 1;
      } else {
        if (tempSliderInit) {
          $('.o-slash-list__list').slick('unslick');
        }
        tempSliderInit = 0;
      }
    });
  }

});